export default {
  methods: {
    onHover(event) {
      const canvas = event.target;
      canvas.style.cursor = 'pointer';
    },
    onLeave(event) {
      const canvas = event.target;
      canvas.style.cursor = 'default';
    },
  },
};
